import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'app-card-panel',
  templateUrl: './card-panel.html',
})
export class CardPanel {
  title = input.required<string>();

  showContent = signal(false);

  toggleReports(): void {
    this.showContent.update(v => !v);
  }
}
